/**
 *
 *    THIS IS COPIED CODE FROM THE ORIGINAL FILE WITH A FEW CHANGES TO MAKE IT WORK IN THE REACT CONTEXT.
 *    THIS SHOULD BE REFACTORED ONCE FINISHED
 *
 */
import { getConfig } from '@fec/assets/js/utils/config';
import moment from 'moment';

const IL_SHOW_URL = 'searchResultShowList.json?pageSize=8&q=';
const IL_MEDIA_URL =
  'searchResultMediaList.json?pageSize=8&includeAggregations=true&q=';

const PLAY_LINK_MEDIA_PATTERN =
  '/play/%type%/cms-site-search/%mediaType%/media?id=';

const AUDIO_LINK_MEDIA_PATTERN = '/redirect/byaudioid/';
const AUDIO_LINK_SHOW_PATTERN = '/redirect/byshowid/';

const PLAY_LINK_SHOW_PATTERN_SRF = '/play/%type%/sendung/cms-site-search?id=';
const PLAY_LINK_SHOW_PATTERN_RTS = '/play/%type%/emissiuns/cms-site-search?id=';

/**
 * Play search converts play data to the following structure and allows to display that structure accordingly.
 */

export class PlayClient {
  constructor(config) {
    const bu = getConfig()['BUSINESS_UNIT'];
    this.playEndpoint = config.play_endpoint + bu + '/';
    this.playLink = config.play_link;
    this.playLinkShowPattern =
      bu === 'srf' ? PLAY_LINK_SHOW_PATTERN_SRF : PLAY_LINK_SHOW_PATTERN_RTS;
    this.keyword = '';
    this.dateFilter = '';
  }

  /**
   *
   * returns a promise which resolves to a list of max. entries using the structure below.
   *
   * @param keyword
   * @param dateFilter
   * @returns {Promise<{hits: {shows: [], media: []}}>}
   *
   * example:
  { hits: {
		shows: [{
			urn: '',
			title: '',
			image: '',
			imageTitle: '',
			type: 'video|audio',
			link: '/play/tv/sendung/cms-site-search?id=',
			description: ''
		}],
		media: [{
			urn: '',
			title: '',
			image: '',
			imageTitle: '',
			link: 'https://www.srf.ch/play/cms-site-search?id=44ef8c85-cf55-4538-ba98-8ab2045f01ba',
			description: '',
			type: 'video|audio',
			date: '',
			show: {
				urn: '',
				title: '',
				image: '',
				imageTitle: '',
				link: '',
				description: ''
			}

		}],
	  }
  }
   *
   */
  search(keyword, dateFilter) {
    this.keyword = keyword; // for paging
    this.dateFilter = dateFilter.play ? dateFilter.play : 'all';

    let dateFilterString =
      this.dateFilter === 'all'
        ? ''
        : `&publishedDateFrom=${
            this.dateFilter
          }&publishedDateTo=${moment().format('YYYY-MM-DD')}`;
    let requestMap = [
      $.get(this.playEndpoint + IL_MEDIA_URL + keyword + dateFilterString),
    ];
    if (this.dateFilter === 'all') {
      requestMap.push($.get(this.playEndpoint + IL_SHOW_URL + keyword));
    }
    // map to generic show/media structure
    return Promise.all(requestMap)
      .then((results) => {
        let media = results[0].searchResultMediaList;
        let shows = results[1] ? results[1].searchResultShowList : [];
        if (shows) {
          shows = shows.map((show) => {
            return this.mapShow(show);
          });
        }
        if (media) {
          media = media.map((media) => {
            return this.mapMedia(media);
          });
        }
        this.shortBalanced(shows, media);
        let result = {
          hits: {
            shows: shows,
            media: media,
          },
          //mapping the deeply nested counter to a more readable structure
          counter: results[0].aggregations.mediaTypeList.reduce(
            (acc, curr) => (
              (acc[curr.mediaType.toLowerCase()] = curr.count), acc
            ),
            {},
          ),
          count: results[0].total + (results[1] ? results[1].total : 0),
          hasNext: !!results[0].next,
        };

        return result;
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        //on Error display nothing
        return {
          hits: {
            shows: [],
            media: [],
          },
        };
      });
  }

  // converter functions to call mapping by name
  mapShow(show) {
    let type = show.urn.indexOf(':tv:') >= 0 ? 'tv' : 'radio';
    return {
      'urn:': show.urn,
      title: show.title,
      image: show.imageUrl,
      imageTitle: show.imageTitle,
      type: type === 'tv' ? 'video' : 'audio',
      link:
        type === 'radio'
          ? AUDIO_LINK_SHOW_PATTERN + show.urn
          : this.playLinkShowPattern.replace('%type%', type) + show.id,
      description: show.description,
    };
  }

  mapMedia(media) {
    let type = 'radio';
    let mediaType = 'audio';
    if (media.urn.indexOf(':video:') >= 0) {
      type = 'tv';
      mediaType = 'video';
    }
    let result = this.mapShow(media);
    result.date = media.date;
    result.duration = media.duration;
    result.type = media.mediaType;
    result.show = this.mapShow(media.show);
    if (mediaType === 'audio') {
      result.link = AUDIO_LINK_MEDIA_PATTERN + media.id;
    } else {
      result.link =
        PLAY_LINK_MEDIA_PATTERN.replace('%type%', type).replace(
          '%mediaType%',
          mediaType,
        ) + media.id;
    }

    return result;
  }

  /*
   * Try to find a balance between both shows/media result sets, and display max. 8 cumulated results.
   * This method works on the sets and shorts them.
   */
  shortBalanced(shows, media) {
    // simple case 1: enough of both, return 4 and 4.
    if (shows.length >= 4 && media.length >= 4) {
      shows.length = 4;
      media.length = 4;
    }

    // simple case 2: do nothing if its too short to fill up
    if (shows.length <= 4 && media.length <= 4) {
      return;
    }

    // 3: keep the whole shorter set and shorten the longer set accordingly.
    let orderedByLength =
      shows.length < media.length ? [shows, media] : [media, shows]; // shorter set first
    let trim = 8 - orderedByLength[0].length; // 8 is the maximum fetched resultset for shows and media.
    // now we short the longer to the padding
    orderedByLength[1].length = trim;
  }
}
